import styled from "styled-components";

export const Root = styled.div`
  min-height: 100dvh;
  width: 100%;
  background-color: #f0f0f5;
`;

export const Container = styled.div``;

export const ContainerButton = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 760px;
  padding: 1.2rem 1.6rem;
  background: linear-gradient(to bottom, transparent, #f0f0f5 28%);

  @media (min-width: 761px) {
    padding: 1.2rem 2.4rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 2.4rem 1.6rem 12rem;
  background-color: #f0f0f5;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 3.2rem 2.4rem 12rem;
  }
`;

export const MissingStudentsBox = styled.section`
  font-size: 12px;

  background-color: #f7e5b2;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #f7c94a;

  color: #7d5c01;
  strong {
    font-size: 14px;
  }
`;
